export default __webpack_public_path__ + "static/media/M_wdt_c_cap_0.276e3e45.mp3";